import styled from "styled-components";

const Container = styled.div``;

const Bar = styled.div`
  height: 10px;
  width: 320px;
  background-color: #E2E8FF;
  border-radius: 100px;
  padding: 0px;

  div {
    width: 100%;
    height: 100%;
    background-color: #564DE6;
    border-radius: 100px;
  }
`;

const CountBox = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: #564DE6;
  
  span:first-child {
    display: block;
    width: 32px;
  }
`;

interface ProgressBarProps {
  index: number;
  total: number;
}

export default function ProgressBar({index, total}: ProgressBarProps) {
  const percent = index / total * 100;

  return <Container>
    <Bar>
      <div style={{width: `${percent}%`}}></div>
    </Bar>
    <CountBox>
      <span>{index}</span>
      <span>{`/`}</span>
      <span>{total}</span>
    </CountBox>
  </Container>
}